export function getEntityTabSubTabDefaultItemLabel({ count, text }) {
  return count != null ? `${text} (${count})` : text
}

export function getEntityTabSubTabItems({
  counters,
  subTabOrder,
  t,
  textKeys,
}) {
  return subTabOrder.map(value => ({
    count: counters?.[value],
    text: t(textKeys[value]),
    value,
  }))
}
